import { useState } from 'react';
import CarbonCreditCardService from './carbonCreditCard.service';

const CarbonCreditCardLogic = () => {
  const [errors, setErrors] = useState({});
  const [values, setValues] = useState({});

  const sendCertificate = async (id) => {
    try {
      const response = await CarbonCreditCardService().generateCertificate(id);
      // console.log('response:' + JSON.stringify(response));

      if (response && response.response && response.response.data && response.response.data.url) window.open(response.response.data.url, '_blank');

    } catch (error) {
      console.error('Error', error);
      setErrors({ certificateGeneration: 'Error al generar el certificado' });
    }
  };

  return {
    errors,
    sendCertificate,
    setValues,
    values,
  };
};
export default CarbonCreditCardLogic;
